import { render, staticRenderFns } from "./PostulantPaymentsVouchers.vue?vue&type=template&id=1b11a45d&"
import script from "./PostulantPaymentsVouchers.vue?vue&type=script&lang=js&"
export * from "./PostulantPaymentsVouchers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports